<template>
  <v-container>
    <div v-if="form.agree">
      <div class="d-flex justify-center text-h6">
        <span v-if="form.agree" class="text-center">Payment</span>
      </div>
      <v-alert
        v-if="paymentAlert.show"
        dense
        :type="paymentAlert.type"
        class="mt-2"
      >
        {{ paymentAlert.message }}
      </v-alert>

      <v-row v-if="form" dense class="mt-3">
        <v-col cols="12" sm="3" class="py-1 px-1">
          <v-card class="pa-3 rounded-lg" outlined height="100%">
            <div
              class="text-caption font-weight-medium grey--text text--darken-1"
            >
              Application ID
            </div>
            <div
              class="text-body-1 font-weight-bold grey--text text--darken-3 mt-1"
            >
              {{ form.application_id || "..." }}
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" sm="3" class="py-1 px-1">
          <v-card class="pa-3 rounded-lg" outlined height="100%">
            <div
              class="text-caption font-weight-medium grey--text text--darken-1"
            >
              Name
            </div>
            <div
              class="text-body-1 font-weight-bold grey--text text--darken-3 mt-1"
            >
              {{ form.name || "..." }}
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" sm="3" class="py-1 px-1">
          <v-card class="pa-3 rounded-lg" outlined height="100%">
            <div
              class="text-caption font-weight-medium grey--text text--darken-1"
            >
              Email
            </div>
            <div
              class="text-body-1 font-weight-bold grey--text text--darken-3 mt-1 text-truncate"
            >
              {{ form.email || "..." }}
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" sm="3" class="py-1 px-1">
          <v-card class="pa-3 rounded-lg" outlined height="100%">
            <div
              class="text-caption font-weight-medium grey--text text--darken-1"
            >
              Mobile
            </div>
            <div
              class="text-body-1 font-weight-bold grey--text text--darken-3 mt-1"
            >
              {{
                form.mobile_prefix && form.mobile_no
                  ? `${form.mobile_prefix} ${form.mobile_no}`
                  : "..."
              }}
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" sm="3" class="py-1 px-1">
          <v-card class="pa-3 rounded-lg" outlined height="100%">
            <div
              class="text-caption font-weight-medium grey--text text--darken-1"
            >
              Program
            </div>
            <div
              class="text-body-1 font-weight-bold grey--text text--darken-3 mt-1"
            >
              {{ programName || "..." }}
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" sm="3" class="py-1 px-1">
          <v-card class="pa-3 rounded-lg" outlined height="100%">
            <div
              class="text-caption font-weight-medium grey--text text--darken-1"
            >
              Batch
            </div>
            <div
              class="text-body-1 font-weight-bold grey--text text--darken-3 mt-1"
            >
              {{
                form.year && form.batch ? `${form.year} - ${form.batch}` : "..."
              }}
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" sm="3" class="py-1 px-1">
          <v-card class="pa-3 rounded-lg" outlined height="100%">
            <div
              class="text-caption font-weight-medium grey--text text--darken-1"
            >
              Application Status
            </div>
            <div class="d-flex align-center mt-1">
              <v-icon small color="success" class="mr-1"
                >mdi-check-circle</v-icon
              >
              <span
                class="text-body-1 font-weight-bold grey--text text--darken-3"
                >{{ form.application_status || "..." }}</span
              >
            </div>
          </v-card>
        </v-col>

        <!-- <v-col cols="12" sm="3" class="py-1 px-1">
          <v-card class="pa-3 rounded-lg" outlined height="100%">
            <div
              class="text-caption font-weight-medium grey--text text--darken-1"
            >
              Pay on or before
            </div>
            <div
              class="text-body-1 font-weight-bold grey--text text--darken-3 mt-1"
            >
              {{ getPayByDate() }}
            </div>
          </v-card>
        </v-col> -->
      </v-row>

      <v-row class="d-flex justify-center">
        <v-col cols="12" md="5" class="py-2 px-3">
          <v-card class="h-100 position-relative" elevation="2">
            <v-card-title v-if="!loadPaymentData">
              <v-icon left color="primary">mdi-check-circle</v-icon>
              <span class="text-body-1 font-weight-bold"
                >Current Plan - {{ currentPlan.name }}</span
              >
              <v-spacer></v-spacer>
              <v-btn
                v-if="currentPlan.balanceToPay > 0 && showChangePlan()"
                class="indigo--text"
                text
                @click="viewOtherPlans"
                ><v-icon small class="mr-1">mdi-reload</v-icon> Change
                Plan</v-btn
              >
            </v-card-title>
            <div
              v-if="loadPaymentData"
              class="py-10 d-flex align-middle justify-center"
            >
              <v-progress-circular
                :value="100"
                color="primary"
                indeterminate
              ></v-progress-circular>
            </div>
            <div class="px-6 pb-6" v-else>
              <div class="d-flex justify-space-between text-caption">
                {{ currentPlan.name }}:
                <span class="font-weight-bold"
                  >₹{{ formatAmount(currentPlan.selectedAmount) }}</span
                >
              </div>
              <div
                class="d-flex justify-space-between text-caption"
                v-if="paymentData.admission_fee > 0"
              >
                Admission Fee:
                <span class="font-weight-bold"
                  >₹{{ formatAmount(currentPlan.admission_fee) }}</span
                >
              </div>
              <div
                class="d-flex justify-space-between text-caption"
                v-if="paymentData.advance_paid > 0"
              >
                Advance Tuition Fee:
                <span class="font-weight-bold"
                  >- ₹{{ formatAmount(currentPlan.advance_fee) }}</span
                >
              </div>
              <div
                class="d-flex justify-space-between text-caption"
                v-if="discount_amount"
              >
                Discount:
                <span class="font-weight-bold"
                  >- ₹{{ formatAmount(discount_amount) }}</span
                >
              </div>
              <div
                v-if="currentPlan.plan_amount_paid > 0"
                class="d-flex justify-space-between text-caption"
              >
                Amount Paid:
                <span class="font-weight-bold"
                  >- ₹{{ formatAmount(currentPlan.plan_amount_paid) }}</span
                >
              </div>
              <v-divider class="my-2"></v-divider>
              <div
                class="d-flex justify-space-between text-body-1 font-weight-semibold mt-1"
              >
                <strong>Balance to be Paid:</strong>
                <span class="font-weight-bold success--text"
                  >₹{{ formatAmount(currentPlan.balanceToPay) }}</span
                >
              </div>

              <div
                v-if="
                  paymentData.option_selected &&
                  paymentData.option_selected !== 'Direct'
                "
                class="mt-3"
              >
                <v-alert
                  :color="getOptionAlertType(paymentData.option_selected)"
                  dense
                  border="left"
                  dark
                  class="mb-0"
                >
                  <div class="d-flex align-center">
                    <v-icon small class="mr-2">
                      {{ getOptionIcon(paymentData.option_selected) }}
                    </v-icon>
                    <span class="text-caption font-weight-bold">
                      {{ getOptionMessage(paymentData.option_selected) }}
                    </span>
                  </div>
                </v-alert>
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-col cols="12" sm="10" md="8" lg="6" class="text-center py-4">
          <v-card elevation="0">
            <v-container fluid class="pa-0">
              <div
                v-if="
                  (paymentData.option_selected === 'Installment' ||
                    paymentData.option_selected === 'Loan') &&
                  currentPlan.balanceToPay > 0
                "
              >
                <v-row class="align-center justify-center" dense>
                  <v-col cols="12" sm="8" class="py-1">
                    <v-text-field
                      v-model="installmentAmount"
                      label="Enter Amount to Pay"
                      outlined
                      dense
                      :min="1"
                      :max="currentPlan.balanceToPay"
                      :rules="[rules.required, rules.amount]"
                      suffix="₹"
                      class="mb-2"
                      hint="Please enter the amount to be paid"
                      persistent-hint
                    ></v-text-field>
                  </v-col>
                </v-row>
              </div>

              <div v-else-if="paymentData.option_selected === 'Loan'">
                <v-row class="align-center justify-center" dense>
                  <v-col cols="12" class="py-1">
                    <v-alert type="info" class="mb-3">
                      <div class="text-body-2 font-weight-bold">
                        Contact the student counselor for further payment
                        processing
                      </div>
                      <div class="text-caption mt-1">
                        Your loan application has been sent to student
                        counselor. Please reach out to your assigned counselor
                        to complete the payment procedure.
                      </div>
                    </v-alert>
                  </v-col>
                </v-row>
              </div>

              <v-row class="align-center justify-center" dense>
                <v-col cols="12" sm="auto" class="py-1">
                  <v-btn
                    color="error"
                    @click="goToLogin"
                    block
                    :class="{ 'mr-sm-2': $vuetify.breakpoint.smAndUp }"
                  >
                    {{
                      payment_status && payment_status === "0300"
                        ? "Back"
                        : "Cancel"
                    }}
                  </v-btn>
                </v-col>

                <v-col
                  v-if="
                    payment_status && paymentData.option_selected !== 'Loan'
                  "
                  cols="12"
                  sm="auto"
                  class="py-1"
                >
                  <v-btn
                    color="success"
                    @click="showPaymentDialog = true"
                    block
                    :class="{ 'mr-sm-2': $vuetify.breakpoint.smAndUp }"
                  >
                    Check payment status
                  </v-btn>
                </v-col>

                <v-col
                  v-if="
                    payment_status === '0300' && currentSelectedOption != 'skip' && fee_type != 'Add-on Programme' && addonfeeSchedules.length > 0 &&
                    applicant_addon_programmes?.is_amount_paid !== true
                  "
                  cols="12"
                  sm="auto"
                  class="py-1"
                >
                  <v-btn
                    color="green"
                    dark
                    @click="showAddonProgrammes"
                    block
                    :class="{ 'mr-sm-2': $vuetify.breakpoint.smAndUp }"
                  >
                    <v-icon left>mdi-lock</v-icon>
                    Pay Add-on Programme
                  </v-btn>
                </v-col>

                <v-col
                  cols="12"
                  sm="auto"
                  class="py-1"
                  v-if="
                    currentPlan.balanceToPay > 0 &&
                    !partner.partner_payment_required
                  "
                >
                  <template v-if="paymentEnabled && !isPayByDateExpired">
                    <v-btn
                      v-if="
                        paymentData.option_selected !== 'Installment' ||
                        paymentData.option_selected !== 'Loan'
                      "
                      color="green"
                      dark
                      @click="proceedToPayment"
                      :loading="loading"
                      block
                    >
                      <v-icon left>mdi-lock</v-icon>
                      <span>Pay Now</span>
                    </v-btn>
                    <v-btn
                      v-else
                      color="green"
                      dark
                      block
                      @click="proceedInstallmentPayment"
                      :loading="loading"
                    >
                      <v-icon left>mdi-lock</v-icon>
                      PAY NOW
                    </v-btn>
                  </template>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <div v-else class="d-flex justify-center">
      <v-progress-linear
        color="primary"
        indeterminate
        rounded
        style="width: 400px"
        height="6"
      ></v-progress-linear>
    </div>

    <v-dialog v-model="showPaymentDialog" max-width="520px" persistent>
      <v-card class="px-4 rounded-xl elevation-12">
        <v-card-title class="text-h6 font-weight-bold text-primary">
          Payment Details <v-spacer></v-spacer>
          <v-btn icon large @click="showPaymentDialog = false">
            <v-icon small color="red">mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pb-6">
          <v-simple-table dense class="text-caption">
            <template v-slot:default>
              <tbody v-if="payment_status === '0300'">
                <tr>
                  <td class="font-weight-bold pr-4 pl-0">Name</td>
                  <td>{{ form.name || "..." }}</td>
                </tr>
                <tr>
                  <td class="font-weight-bold pr-4 pl-0">Application ID</td>
                  <td>{{ form.application_id || "..." }}</td>
                </tr>
                <tr>
                  <td class="font-weight-bold pr-4 pl-0">USN</td>
                  <td>{{ paymentData.usn_id || "..." }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>

          <v-simple-table dense class="text-caption mt-3">
            <template v-slot:default>
              <tbody>
                <tr v-if="fee_type== 'Add-on Programme'">
                  <td class="font-weight-bold pr-4 pl-0">Particular</td>
                  <td>Add-on Programme</td>
                </tr>
                <tr>
                  <td class="font-weight-bold pr-4 pl-0">Bank Ref. No</td>
                  <td>{{ payment_order_status.bank_ref_no }}</td>
                </tr>
                <tr>
                  <td class="font-weight-bold pr-4 pl-0">Bank ID</td>
                  <td>{{ payment_order_status.bankid }}</td>
                </tr>
                <tr>
                  <td class="font-weight-bold pr-4 pl-0">Amount</td>
                  <td>₹{{ formatAmount(payment_order_status.amount) }}</td>
                </tr>
                <tr>
                  <td class="font-weight-bold pr-4 pl-0">Mode</td>
                  <td>
                    {{ payment_order_status.payment_method_type }}
                  </td>
                </tr>
                <tr>
                  <td class="font-weight-bold pr-4 pl-0">Payment Status</td>
                  <td
                    :class="{
                      'error--text':
                        payment_order_status.auth_status === '0399' ||
                        payment_order_status.auth_status === 'NOT RECEIVED',
                      'warning--text':
                        payment_order_status.auth_status === '0002',
                      'success--text':
                        payment_order_status.auth_status !== '0399' &&
                        payment_order_status.auth_status !== '0002' &&
                        payment_order_status.auth_status !== 'NOT RECEIVED',
                    }"
                  >
                    {{
                      payment_order_status.auth_status === "0399"
                        ? "Failed"
                        : payment_order_status.auth_status === "0002"
                        ? "Pending"
                        : payment_order_status.auth_status === "NOT RECEIVED"
                        ? "Amount not received"
                        : payment_order_status.auth_status === "0300"
                        ? "Success"
                        : payment_order_status.auth_status
                    }}
                  </td>
                </tr>
                <tr>
                  <td class="font-weight-bold pr-4 pl-0">Transaction Status</td>
                  <td>{{ payment_order_status.transaction_error_desc }}</td>
                </tr>
                <tr>
                  <td class="font-weight-bold pr-4 pl-0">Transaction ID</td>
                  <td>
                    {{ payment_order_status.transactionid }}
                    <v-btn
                      icon
                      small
                      @click="
                        copyToClipboard(payment_order_status.transactionid)
                      "
                    >
                      <v-icon small class="ml-1">mdi-content-copy</v-icon>
                    </v-btn>
                  </td>
                </tr>
                <tr>
                  <td class="font-weight-bold pr-4 pl-0">Transaction Date</td>
                  <td>
                    {{ payment_order_status.transaction_date }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="viewPlanDialog" persistent max-width="850px">
      <v-card class="h-100" elevation="2">
        <v-card-title class="text-h6">
          Choose New Plan <v-spacer></v-spacer>
          <v-btn icon large @click="viewPlanDialog = false">
            <v-icon small color="red">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="px-4 px-sm-6 pt-0">
          <v-row
            class="d-flex justify-center text-2xl mt-3"
            v-if="availablePlans.length == 0"
          >
            No Plans available</v-row
          >
          <v-radio-group v-model="selectedPlan" class="mt-0">
            <v-row class="d-flex justify-center">
              <v-col
                v-for="plan in availablePlans"
                :key="plan.id"
                cols="12"
                sm="6"
                md="4"
                class="d-flex"
              >
                <v-radio
                  :value="plan.id"
                  color="primary"
                  :disabled="plan.balanceToPay <= 0"
                  class="flex-grow-1"
                >
                  <template v-slot:label>
                    <v-card
                      :class="[
                        'pa-3 pa-sm-4 flex-grow-1',
                        selectedPlan === plan.id ? 'secondary lighten-2' : '',
                        plan.balanceToPay <= 0 ? 'grey lighten-4' : '',
                      ]"
                      class="d-flex align-center"
                      :elevation="selectedPlan === plan.id ? 4 : 2"
                      outlined
                      style="
                        cursor: pointer;
                        transition: all 0.3s ease;
                        min-height: 230px;
                        height: auto;
                      "
                      @click="
                        selectedPlan =
                          plan.balanceToPay > 0 ? plan.id : selectedPlan
                      "
                    >
                      <div class="text-center">
                        <div
                          class="text-subtitle-1 text-sm-h6 font-weight-bold primary--text mb-2 mb-sm-3"
                        >
                          {{ plan.name }}
                        </div>

                        <div class="text-left">
                          <div
                            class="d-flex justify-space-between text-caption"
                          >
                            <span>{{ plan.name }}:</span>
                            <span class="font-weight-bold"
                              >₹{{ formatAmount(plan.amount) }}</span
                            >
                          </div>
                          <div
                            v-if="plan.admission_fee > 0"
                            class="d-flex justify-space-between text-caption"
                          >
                            <span>Admission Fee:</span>
                            <span class="font-weight-bold"
                              >₹{{ formatAmount(plan.admission_fee) }}</span
                            >
                          </div>
                          <div
                            class="d-flex justify-space-between text-caption"
                            v-if="plan.advance_paid > 0"
                          >
                            <span>Advance Tuition Fee:</span>
                            <span class="font-weight-bold"
                              >- ₹{{ formatAmount(plan.advance_fee) }}</span
                            >
                          </div>
                          <div
                            class="d-flex justify-space-between text-caption"
                            v-if="discount_amount"
                          >
                            Discount:
                            <span class="font-weight-bold"
                              >- ₹{{ formatAmount(discount_amount) }}</span
                            >
                          </div>
                          <div
                            class="d-flex justify-space-between text-caption"
                            v-if="plan.plan_amount_paid > 0"
                          >
                            <span>Amount Paid:</span>
                            <span class="font-weight-bold"
                              >- ₹{{
                                formatAmount(plan.plan_amount_paid)
                              }}</span
                            >
                          </div>

                          <v-divider class="my-2"></v-divider>

                          <div
                            v-if="plan.balanceToPay >= 0"
                            class="d-flex justify-space-between text-caption font-weight-bold"
                          >
                            Balance to be Paid:
                            <span class="font-weight-bold success--text"
                              >₹{{ formatAmount(plan.balanceToPay) }}</span
                            >
                          </div>
                          <div
                            v-if="
                              plan.balanceToPay > 0 &&
                              (plan.loanAllowed || plan.installmentAllowed)
                            "
                          >
                            <v-chip-group
                              column
                              class="d-flex align-center justify-center"
                            >
                              <v-chip
                                v-if="plan.loanAllowed"
                                small
                                class="mr-1"
                              >
                                <v-icon x-small left>mdi-bank</v-icon>
                                Loan
                              </v-chip>
                              <v-chip
                                v-if="plan.installmentAllowed"
                                small
                                class="ml-1"
                              >
                                <v-icon x-small left>mdi-calendar-clock</v-icon>
                                Installment
                              </v-chip>
                            </v-chip-group>
                          </div>
                        </div>

                        <div
                          v-if="plan.balanceToPay <= 0"
                          class="text-caption success--text text-center mt-2"
                        >
                          <v-icon small color="success" class="mr-1"
                            >mdi-check-circle</v-icon
                          >
                          Already Paid
                        </div>
                      </div>
                    </v-card>
                  </template>
                </v-radio>
              </v-col>
            </v-row>
          </v-radio-group>

          <v-expand-transition>
            <div v-if="showselectedPlanOptions">
              <v-card class="px-2 px-sm-4" elevation="0">
                <div class="text-caption font-weight-bold primary--text mb-2">
                  Payment Options for {{ getSelectedPlanName }}
                </div>

                <v-row class="justify-center pa-2">
                  <v-col
                    cols="12"
                    sm="6"
                    md="4"
                    class="py-1"
                    v-if="disableSelectedPlan() !== 'direct'"
                  >
                    <v-card
                      class="pa-3 text-center"
                      outlined
                      hover
                      @click="selectPaymentOption('direct')"
                      style="
                        cursor: pointer;
                        height: 100%;
                        min-height: 120px;
                        transition: all 0.3s ease;
                      "
                    >
                      <v-icon large color="green" class="mb-1"
                        >mdi-cash-multiple</v-icon
                      >
                      <div
                        class="text-subtitle-2 text-sm-subtitle-1 font-weight-bold"
                      >
                        Single Payment
                        <v-icon
                          v-if="selectedPaymentOption === 'direct'"
                          small
                          color="primary"
                          >mdi-check-circle</v-icon
                        >
                      </div>
                      <div class="text-caption text--secondary">
                        Pay full amount now
                      </div>
                      <div
                        class="text-body-2 text-sm-h6 font-weight-bold success--text mt-1"
                      >
                        ₹{{ formatAmount(getSelectedPlanBalance) }}
                      </div>
                    </v-card>
                  </v-col>

                  <v-col
                    cols="12"
                    sm="6"
                    md="4"
                    class="py-1"
                    v-if="
                      getSelectedPlan.loanAllowed &&
                      disableSelectedPlan() !== 'loan'
                    "
                  >
                    <v-card
                      class="pa-3 text-center"
                      outlined
                      hover
                      @click="selectPaymentOption('loan')"
                      style="
                        cursor: pointer;
                        height: 100%;
                        min-height: 120px;
                        transition: all 0.3s ease;
                      "
                    >
                      <v-icon large color="blue" class="mb-1">mdi-bank</v-icon>
                      <div
                        class="text-subtitle-2 text-sm-subtitle-1 font-weight-bold"
                      >
                        Loan
                        <v-icon
                          v-if="selectedPaymentOption === 'loan'"
                          small
                          color="primary"
                          >mdi-check-circle</v-icon
                        >
                      </div>
                      <div class="text-caption text--secondary">
                        Partner financing option
                      </div>
                      <div
                        class="text-caption success--text font-weight-bold mt-1"
                      >
                        Available
                      </div>
                    </v-card>
                  </v-col>

                  <v-col
                    cols="12"
                    sm="6"
                    md="4"
                    class="py-1"
                    v-if="
                      getSelectedPlan.installmentAllowed &&
                      disableSelectedPlan() !== 'installment'
                    "
                  >
                    <v-card
                      class="pa-3 text-center"
                      outlined
                      hover
                      @click="selectPaymentOption('installment')"
                      style="
                        cursor: pointer;
                        height: 100%;
                        min-height: 120px;
                        transition: all 0.3s ease;
                      "
                    >
                      <v-icon large color="orange" class="mb-1"
                        >mdi-calendar-clock</v-icon
                      >
                      <div
                        class="text-subtitle-2 text-sm-subtitle-1 font-weight-bold"
                      >
                        Installments
                        <v-icon
                          small
                          color="primary"
                          v-if="selectedPaymentOption === 'installment'"
                          >mdi-check-circle</v-icon
                        >
                      </div>
                      <div class="text-caption text--secondary">
                        Pay in multiple parts
                      </div>
                      <div
                        class="text-caption success--text font-weight-bold mt-1"
                      >
                        Available
                      </div>
                    </v-card>
                  </v-col>
                </v-row>

                <v-expand-transition>
                  <div v-if="selectedPaymentOption" class="mt-3">
                    <v-alert type="success" dense class="mb-0">
                      <div class="d-flex align-center">
                        <v-icon small class="mr-2">
                          {{
                            selectedPaymentOption === "direct"
                              ? "mdi-cash-multiple"
                              : selectedPaymentOption === "loan"
                              ? "mdi-bank"
                              : "mdi-calendar-clock"
                          }}
                        </v-icon>
                        <span
                          class="text-caption text-sm-body-2 font-weight-bold"
                        >
                          {{ getPaymentOptionText }}
                        </span>
                      </div>
                    </v-alert>
                  </div>
                </v-expand-transition>
              </v-card>
            </div>
          </v-expand-transition>
          <v-row class="d-flex justify-end mt-3">
            <v-btn
              class="mx-2 my-2 primary"
              :disabled="!selectedPlan"
              @click="updateSelectedPlan"
              :loading="loadPaymentData"
            >
              Choose Plan
            </v-btn>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <ProgramAddonsDialog
      v-model="openProgramAddonsDialog"
      :applicant-id="form.id"
      :program-id="form.program_id"
      :partner-id="form.partner_id"
      :batch="form.batch"
      :year="form.year"
      :existing-program-addons="
        applicant_addon_programmes?.program_addons || []
      "
      :existing-program-addon-amount="applicant_addon_programmes?.amount"
      :show-payments=true
      @skipAddons="handleSkipAddons"
      @submit="handleAddonsSubmit"
    />
  </v-container>
</template>

<script>
import env from "@/helpers/env";
import { fetchPaymentEnabled } from "@/helpers/paymentAvailability";
import { rules } from "@/helpers/rules";
import ProgramAddonsDialog from "@/components/ProgramAddonsDialog.vue";
export default {
  name: "PaymentOptionsDialog",
  components: { ProgramAddonsDialog },
  data() {
    return {
      rules,
      form: {},
      selectedOption: null,
      paymentData: {},
      applicantId: null,
      studentPlanId: null,
      viewPlanDialog: false,
      currentPlan: {},
      selectedPlan: null,
      selectedPaymentOption: "direct",
      installmentAmount: null,
      availablePlans: [],
      loadPaymentData: false,
      paymentSelectionForm: {},
      amount: null,
      method: null,
      partnerMode: false,
      daysRemaining: null,
      installmentsDialog: false,
      installmentsList: [],
      installmentsHeaders: [
        {
          text: "Date",
          value: "installment_date",
        },
        {
          text: "Amount",
          value: "amount",
        },
        {
          text: "Transaction Date",
          value: "transaction_date",
        },
        {
          text: "Transaction Id",
          value: "transaction_id",
        },
        {
          text: "Paid",
          value: "status",
        },
      ],
      loading: false,
      installmentMap: {},
      invoiceId: null,
      invoicePending: false,
      paymentPayload: {},
      application_id: null,
      resolution_id: null,
      showPaymentDialog: false,
      payment_status: null,
      payment_order_status: {},
      programName: "",
      admission_end_date: null,
      showInstallmentLabel: "",
      currentType: "",
      type: "",
      partner_payment: false,
      env: env,
      paymentEnabled: false,
      partner: {
        partner_payment_required: true,
      },
      discount_amount: null,
      openProgramAddonsDialog: false,
      applicant_addon_programmes: [],
      currentSelectedOption: {},
      showAddonPaymentSummary: false,
      fee_type: null,
      addonfeeSchedules: [],
    };
  },
  async mounted() {
    fetchPaymentEnabled(this.$axios).then((enabled) => (this.paymentEnabled = enabled));
    this.applicantId = this.$route.query.id;
    this.studentPlanId = this.$route.query.plan_id;
    let order_id = this.$route.query.order_id;
    this.payment_status = this.$route.query.status;
    this.partner_payment = this.$route.query.partner_payment;
    this.fee_type = this.$route.query.fee_type;

    if (order_id) {
      await this.getPaymentOrder(order_id);
    }
    if (this.applicantId) {
      await this.getApplicantDetails(this.applicantId, this.studentPlanId);
      await this.getApplicantAddonProgramme(this.form.application_id);
      await this.fetchFeeSchedules()
    } else {
      this.$router.push("/home");
    }

    if (this.fee_type === "Add-on Programme" && this.payment_status) {
      this.showPaymentDialog = true;
    }

    if (this.payment_status === "0300") {
      if (this.fee_type !== "Add-on Programme" && this.addonfeeSchedules?.length > 0) {
        if (this.applicant_addon_programmes?.is_amount_paid !== true) {
          this.openProgramAddonsDialog = true;
        }
      }
      this.$store.commit("showSnackbar", {
        message: "Payment successful",
        color: "success",
      });
    }
  },
  computed: {
    isPayByDateExpired() {
      if (!this.admission_end_date) return false;
      const [yyyy, mm, dd] = this.admission_end_date.split("-").map(Number);
      const endDateOnly = new Date(yyyy, mm - 1, dd);
      const today = new Date();
      const todayOnly = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate(),
      );
      return todayOnly > endDateOnly;
    },
    paymentAlert() {
      const statusConfig = {
        "0399": {
          show: true,
          type: "error",
          message:
            "Your payment has failed. Please check your payment details and try again. If the issue persists, contact your bank or our support team.",
        },
        "0002": {
          show: true,
          type: "info",
          message:
            "Your payment is pending. Please do not close the browser or refresh the page. It may take a few minutes to process. If the status does not change, please contact your bank or our support team.",
        },
        "NOT RECEIVED": {
          show: true,
          type: "info",
          message:
            "Your payment is not received yet. Please do not close the browser or refresh the page. It may take a few minutes to process. If the status does not change, please contact your bank or our support team.",
        },
      };

      return statusConfig[this.payment_status] || { show: false };
    },
    getSelectedPlan() {
      return (
        this.availablePlans.find((plan) => plan.id === this.selectedPlan) || {}
      );
    },
    getSelectedPlanName() {
      return this.getSelectedPlan.name || "";
    },
    getSelectedPlanBalance() {
      return this.getSelectedPlan.balanceToPay || 0;
    },
    showselectedPlanOptions() {
      const matchingPlan = this.availablePlans.find(
        (plan) => plan.id === this.selectedPlan,
      );
      return matchingPlan?.loanAllowed || matchingPlan?.installmentAllowed;
    },
    getPaymentOptionText() {
      switch (this.selectedPaymentOption) {
        case "direct":
          return `You have selected Single Payment. The full amount of ₹${this.formatAmount(
            this.getSelectedPlanBalance,
          )} will be processed.`;
        case "loan":
          return "You have selected Loan. Contact the student counselor for payment details";
        case "installment":
          return "You have selected Installment Plan. You will be able to pay in multiple parts.";
        default:
          return "";
      }
    },
    filteredPaymentOptions() {
      const options = [];

      if (Number(this.paymentData.term_fee) > 0) {
        options.push({
          label: "Term Fee",
          value: "Term Fee",
          amount: this.paymentData.term_fee,
          amount_to_paid: this.paymentData.term_fee_to_paid,
          advance_fee: this.paymentData.advance_fee,
          admission_fee: this.paymentData.admission_fee,
        });
      }

      if (Number(this.paymentData.annual_upfront) > 0) {
        options.push({
          label: "Annual Upfront",
          value: "Annual",
          amount: this.paymentData.annual_upfront,
          amount_to_paid: this.paymentData.annual_upfront_to_paid,
          advance_fee: this.paymentData.advance_fee,
          admission_fee: this.paymentData.admission_fee,
        });
      }

      if (Number(this.paymentData.full_upfront) > 0) {
        options.push({
          label: "Full Upfront",
          value: "Full",
          amount: this.paymentData.full_upfront,
          amount_to_paid: this.paymentData.full_upfront_to_paid,
          advance_fee: this.paymentData.advance_fee,
          admission_fee: this.paymentData.admission_fee,
        });
      }

      return options;
    },
    formatDate() {
      return (date) => {
        if (!date) return "";
        const [year, month, day] = date.split("-");
        return `${day}-${month}-${year}`;
      };
    },
    orderedInstallments() {
      return this.installmentsList
        .filter((i) => i.status === "Completed")
        .sort((a, b) => a.installment_order - b.installment_order);
    },

    totalInstallmentAmountPaid() {
      return this.installmentsList
        .filter((i) => i.status === "Completed")
        .reduce((sum, i) => sum + parseFloat(i.amount || 0), 0);
    },

    remainingBalance() {
      if (this.method !== "Installment") return 0;

      const pendingInstallments = this.installmentsList
        .filter((inst) => inst.status === "Pending" && inst.type === this.type)
        .sort((a, b) => a.installment_order - b.installment_order);

      const unpaidAmount = pendingInstallments.reduce(
        (sum, inst) => sum + Number(inst.amount),
        0,
      );

      return unpaidAmount;
    },
  },
  methods: {
    viewOtherPlans() {
      this.viewPlanDialog = true;
      this.selectedPlan = null;
      this.selectedPaymentOption = null;
    },

    selectPaymentOption(option) {
      this.selectedPaymentOption = option;
    },

    async updateSelectedPlan() {
      this.loadPaymentData = true;
      this.paymentData.plan_selected = this.selectedPlan;
      const optionMap = {
        direct: "Direct",
        loan: "Loan",
        installment: "Installment",
      };

      this.paymentData.option_selected =
        optionMap[this.selectedPaymentOption] || "Direct";

      this.paymentData.changed_by = this.form.email;

      const data = {
        plan_selected: this.selectedPlan,
        option_selected: optionMap[this.selectedPaymentOption] || "Direct",
        changed_by: this.form.email,
      };

      await this.$axios.put(`/student_admit_plans/${this.paymentData.id}`, {
        student_admit_plan: data,
      });

      this.viewPlanDialog = false;
      await this.getApplicantDetails(this.applicantId, this.studentPlanId);
      this.loadPaymentData = false;

      this.selectedPlan = null;
      this.selectedPaymentOption = null;
    },

    getOptionAlertType(option) {
      const types = {
        Direct: "green",
        Installment: "blue",
        Loan: "blue",
      };
      return types[option];
    },

    getOptionIcon(option) {
      const icons = {
        Direct: "mdi-cash-multiple",
        Installment: "mdi-calendar-clock",
        Loan: "mdi-bank",
      };
      return icons[option];
    },

    getOptionMessage(option) {
      const messages = {
        Direct: "Single Payment - Pay full amount",
        Installment: "Installment Plan - Pay in parts",
        Loan: "Loan",
      };
      return messages[option];
    },

    proceedInstallmentPayment() {
      if (
        this.installmentAmount &&
        this.installmentAmount > 0 &&
        this.installmentAmount <= this.currentPlan.balanceToPay
      ) {
        this.paymentData.plan_amount_to_pay = this.installmentAmount;
        this.proceedToPayment();
      } else {
        if (!this.installmentAmount) {
          this.$store.commit("showSnackbar", {
            message: "Please enter a valid amount to proceed your payment",
            color: "error",
          });
        }
        if (this.installmentAmount > this.currentPlan.balanceToPay) {
          this.$store.commit("showSnackbar", {
            message: "Entered Amount is greater than balance to be paid",
            color: "error",
          });
        }
      }
    },

    async proceedToPayment() {
      const amount =
        this.paymentData.option_selected === "Installment" ||
        this.paymentData.option_selected === "Loan"
          ? this.installmentAmount
          : this.currentPlan.balanceToPay;

      this.paymentData.plan_amount_to_pay = amount;

      this.loading = true;
      if (this.partnerMode) {
        this.partnerBySubmit();
      } else {
        this.submit();
      }
    },

    initializePlans(paymentOptions) {
      const concessionAmount = this.discount_amount
        ? this.discount_amount
        : "0";
      this.currentPlan = {
        id: paymentOptions.plan_selected,
        name:
          paymentOptions.plan_selected == "Term Fee"
            ? paymentOptions.plan_selected
            : paymentOptions.plan_selected + " Upfront",
        term_fee: Number(paymentOptions.term_fee),
        advance_fee: Number(paymentOptions.advance_paid),
        application_fee: Number(paymentOptions.application_fee),
        admission_fee: Number(paymentOptions.admission_fee),
        price: Number(paymentOptions.plan_amount_to_pay),
        balanceToPay: Number(paymentOptions.plan_amount_balance),
        loanAllowed: paymentOptions.term_loan_allowed,
        installmentAllowed: paymentOptions.term_installment_allowed,
        plan_amount_paid: Number(paymentOptions.plan_amount_paid),
        selectedAmount: Number(paymentOptions.plan_amount),
      };

      this.availablePlans = [
        {
          id: "Term Fee",
          name: "Term Fee",
          amount: Number(paymentOptions.term_fee),
          loanAllowed: paymentOptions.term_loan_allowed,
          installmentAllowed: paymentOptions.term_installment_allowed,
          isSelected: paymentOptions.plan_selected === "Term Fee",
          advance_fee: Number(paymentOptions.advance_paid),
          application_fee: Number(paymentOptions.application_fee),
          admission_fee: Number(paymentOptions.admission_fee),
          plan_amount_paid: Number(paymentOptions.plan_amount_paid),
          balanceToPay:
            Number(paymentOptions.term_fee) +
            Number(paymentOptions.admission_fee) -
            Number(paymentOptions.advance_paid) -
            Number(paymentOptions.plan_amount_paid) -
            Number(concessionAmount),
        },
        {
          id: "Annual",
          name: "Annual Upfront",
          amount: Number(paymentOptions.annual_upfront),
          loanAllowed: paymentOptions.annual_upfront_loan_allowed,
          installmentAllowed: paymentOptions.annual_upfront_installment_allowed,
          isSelected: paymentOptions.plan_selected === "Annual Upfront",
          advance_fee: Number(paymentOptions.advance_paid),
          application_fee: Number(paymentOptions.application_fee),
          admission_fee: Number(paymentOptions.admission_fee),
          plan_amount_paid: Number(paymentOptions.plan_amount_paid),
          balanceToPay:
            Number(paymentOptions.annual_upfront) +
            Number(paymentOptions.admission_fee) -
            Number(paymentOptions.advance_paid) -
            Number(paymentOptions.plan_amount_paid) -
            Number(concessionAmount),
        },
        {
          id: "Full",
          name: "Full Upfront",
          amount: Number(paymentOptions.full_upfront),
          loanAllowed: paymentOptions.full_upfront_loan_allowed,
          installmentAllowed: paymentOptions.full_upfront_installment_allowed,
          isSelected: paymentOptions.plan_selected === "Full Upfront",
          advance_fee: Number(paymentOptions.advance_paid),
          application_fee: Number(paymentOptions.application_fee),
          admission_fee: Number(paymentOptions.admission_fee),
          plan_amount_paid: Number(paymentOptions.plan_amount_paid),
          balanceToPay:
            Number(paymentOptions.full_upfront) +
            Number(paymentOptions.admission_fee) -
            Number(paymentOptions.advance_paid) -
            Number(paymentOptions.plan_amount_paid) -
            Number(concessionAmount),
        },
      ];

      this.availablePlans = this.availablePlans.filter(
        (plan) =>
          plan.id != this.currentPlan.id ||
          plan.loanAllowed ||
          plan.installmentAllowed,
      );

      this.availablePlans = this.availablePlans.filter(
        (plan) => plan.amount > 0 && plan.balanceToPay > 0,
      );
    },

    formatAmount(value) {
      if (!value) return "0";
      return new Intl.NumberFormat("en-IN").format(value);
    },
    async partnerBySubmit() {
      this.loading = true;
      const form = {
        type:
          this.method == "Installment"
            ? this.currentType + " - " + this.showInstallmentLabel
            : this.method,
        amount: this.amount,
        status: "Pending",
        invoice_id: this.invoiceId,
      };
      this.getPaymentPayload(form, "partner");
      this.proceedBilldeskPayment();
    },
    async submit() {
      this.loading = true;
      this.getPaymentPayload("student");
      this.$store.commit("showSnackbar", {
        message: "Redirecting to payment gateway...",
        color: "info",
      });
      await this.proceedBilldeskPayment();
    },
    goToLogin() {
      if (this.$route.query.partner_payment) this.$router.go(-1);
      else {
        this.$router.push("/home");
      }
    },
    async getApplicantDetails(applicantId) {
      const applicant_detail = await this.$axios.get(
        `/get_applicant/${applicantId}`,
      );
      this.form = applicant_detail.data.data;
      const [res, total_admission_discount] = await Promise.all([
        this.$axios.get(
          `/get_student_admit_plan_by_application_id/${this.form.application_id}`,
        ),
        this.$axios.get(
          `/total_admission_discount/${this.form.application_id}`,
        ),
      ]);
      this.paymentData = res.data.data;
      this.discount_amount = total_admission_discount.data.data;
      this.getPartner(this.form.partner_code);
      this.getProgram(this.form.program_id);
      this.getProgramSchedule(this.form.batch_partner_schedule_id);
      this.initializePlans(this.paymentData);
    },
    getFixedAmount(type, amount) {
      const fee = parseFloat(amount);
      if (isNaN(fee)) return "0.00";
      if (type == "Direct") return fee.toFixed(2);
      if (type == "Split") return fee.toFixed(2);
    },
    getPaymentPayload(mode) {
      this.paymentPayload = {
        mercid: this.env.merchantid,
        amount: this.getFixedAmount(
          "Direct",
          this.paymentData.plan_amount_to_pay,
        ),
        return_url: this.env.payment_ru,
        additional_info: {
          additional_info1: this.form.application_id,
          additional_info2: this.form.id,
          additional_info3: this.paymentData.id,
          additional_info4: mode,
          additional_info5: this.paymentData.plan_amount_to_pay,
          additional_info6: this.paymentData.plan_selected,
          additional_info7: this.form.email,
        },
        split_payment: this.env.getSplitPayment(
          this.paymentData.plan_amount_to_pay,
        ),
      };
    },
    async createBilldeskHistory(order_id, ecom_order_id, order_ref_no) {
      const selected = this.filteredPaymentOptions.find(
        (opt) => opt.value === this.selectedOption,
      );
      const data = {
        order_id: order_id,
        ecom_order_id: ecom_order_id,
        order_ref_no: order_ref_no,
        name: this.form.name,
        email: this.form.email,
        application_id: this.form.application_id,
        mobile_no: this.form.mobile_no,
        program_id: String(this.form.program_id),
        amount: String(this.paymentData.plan_amount_to_pay),
        current_status: "initiated",
        order_date: new Date(),
        fee_type: this.paymentData.plan_selected,
      };
      await this.$axios
        .post(`/billdesk_track_history`, { billdesk_track_history: data })
        .then((res) => {
          console.log("saved history");
        });
    },
    async proceedBilldeskPayment() {
      this.loading = true;
      await this.$axios
        .post(this.env.billdesk_url, this.paymentPayload)
        .then((res) => {
          if (res.status == 200) {
            const { rdata, bdorderid, order_id, ecom_order_id, order_ref_no } =
              res.data;
            const form = document.createElement("form");
            form.method = "POST";
            form.action = this.env.billdesk_sdk_url;
            form.style.display = "none";
            const inputs = {
              bdorderid,
              merchantid: this.env.merchantid,
              rdata,
            };
            Object.entries(inputs).forEach(([name, value]) => {
              const input = document.createElement("input");
              input.type = "hidden";
              input.name = name;
              input.value = value;
              form.appendChild(input);
            });
            document.body.appendChild(form);
            this.createBilldeskHistory(
              order_id,
              ecom_order_id,
              order_ref_no,
            ).then(() => {
              this.loading = false;
              form.submit();
            });
            this.loading = false;
          } else {
            this.$store.commit("showSnackbar", {
              message: res.data.message,
              color: "error",
            });
          }
        })
        .catch(() => {
          this.loading = false;
          this.$store.commit("showSnackbar", {
            message: "Error in payment, Please try again",
            color: "error",
          });
        });
    },
    async getPaymentOrder(orderid) {
      this.$axios.get("get_payment_order/" + orderid).then((res) => {
        this.payment_order_status = res.data.data;
        this.payment_status = this.payment_order_status.auth_status;
      });
    },
    copyToClipboard(text) {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          this.$store.commit("showSnackbar", {
            message: "Copied to clipboard",
            color: "success",
          });
        })
        .catch((err) => {
          this.$store.commit("showSnackbar", {
            message: "Failed to copy",
            color: "error",
          });
        });
    },
    getPartner(code) {
      this.$axios
        .get(`/partners/get_by_code/${code}`)
        .then((res) => {
          this.partner = res.data.data;
        })
        .catch((error) => {
          console.error("Error fetching program:", error);
        });
    },
    getProgram(id) {
      return this.$axios
        .get(`programs/${id}`)
        .then((res) => {
          const program = res.data.data;
          this.programName =
            program.degree.short_name +
            (program.specialization ? " - " + program.specialization : "");
        })
        .catch((error) => {
          console.error("Error fetching program:", error);
        });
    },
    getProgramSchedule(id) {
      return this.$axios
        .get(`batch_partner_schedules/${id}`)
        .then((res) => {
          const program_schedule = res.data.data;
          if (!program_schedule.pay_by_date) {
            this.admission_end_date = null;
            return;
          }
          const payByDate = new Date(program_schedule.pay_by_date);
          this.admission_end_date = payByDate.toISOString().split("T")[0];
        })
        .catch((error) => {
          console.error("Error fetching program:", error);
        });
    },
    disableSelectedPlan() {
      const selectedPlan = this.paymentData?.plan_selected?.toLowerCase();
      const selectedPaymentOption =
        this.paymentData?.option_selected?.toLowerCase();
      return (
        selectedPlan &&
        this.selectedPlan?.toLowerCase() === selectedPlan &&
        selectedPaymentOption
      );
    },
    showChangePlan() {
      if (this.partner_payment && this.form.partner_type === "Business")
        return true;
      if (this.form.partner_type !== "Business") return true;
    },
    getTypeName(type) {
      if (type == "Annual") return "Annual Upfront";
      if (type == "Term Fee") return "Term Fee";
      if (type == "Full") return "Full Upfront";
    },
    getPayByDate() {
      const date = new Date(this.admission_end_date);
      const today = new Date();

      const endDateOnly = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
      );
      const todayOnly = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate(),
      );

      const finalDate = endDateOnly < todayOnly ? todayOnly : endDateOnly;

      const dd = String(finalDate.getDate()).padStart(2, "0");
      const mm = String(finalDate.getMonth() + 1).padStart(2, "0");
      const yyyy = finalDate.getFullYear();

      return `${dd}-${mm}-${yyyy}`;
    },

    async handleAddonsSubmit(selectedOption) {
      console.log("Selected add-ons:", selectedOption);
      this.currentSelectedAddon = selectedOption;
      this.currentSelectedOption = selectedOption.paymentOption;

      if (selectedOption.paymentOption === "later") {
        const invoiceData = await this.createInvoice(selectedOption);
        const invoiceId = invoiceData.id;

        const payload = {
          student_program_addons: {
            application_id: this.form.application_id,
            usn_id: this.form.usn_id,
            amount: selectedOption.totalAmount,
            program_addons: selectedOption.ids,
            is_amount_paid: false,
            convinced_by_partner: this.form.partner_id,
            status: "Pending",
            invoice_id: invoiceId,
          },
        };

        await this.createStudentAddonProgramme(payload);
      } else {
        // Create invoice first, then student addon with invoice_id, then pay
        const invoiceData = await this.createInvoice(selectedOption);
        const invoiceId = invoiceData.id;

        const payload = {
          student_program_addons: {
            application_id: this.form.application_id,
            usn_id: this.form.usn_id,
            amount: selectedOption.totalAmount,
            program_addons: selectedOption.ids,
            is_amount_paid: false,
            convinced_by_partner: this.form.partner_id,
            status: "Pending",
            invoice_id: invoiceId,
          },
        };

        await this.createStudentAddonProgramme(payload);
        await this.processPayment(selectedOption, invoiceId);
      }
    },

    async createStudentAddonProgramme(payload = null) {
      if (!payload) {
        payload = {
          student_program_addons: {
            application_id: this.form.application_id,
            usn_id: this.usn_id || null,
            amount: this.currentSelectedAddon?.totalAmount,
            program_addons: this.currentSelectedAddon?.ids,
            is_amount_paid: false,
            convinced_by_partner: this.form.partner_id,
            status: "Pending",
          },
        };
      }

      try {
        const response = await this.$axios.post(
          "/create_student_program_addon",
          payload,
        );
        if (response.data.data) {
          this.$store.commit("showSnackbar", {
            message: "Add-on programme created successfully",
            color: "success",
          });
          return response.data.data;
        }
      } catch (error) {
        console.error("Error creating student addon programme:", error);
      }
    },

    async createInvoice(selectedOption) {
      try {
        const invoiceData = {
          application_id: this.form.application_id,
          usn_id: this.form.usn_id,
          type: "Addon-Programme",
          amount: selectedOption.totalAmount,
          from_date: new Date().toISOString().split("T")[0],
          to_date: this.getMaxEnrollmentDeadline(selectedOption.details),
          program_add_ons: selectedOption.ids,
          is_combined_with_tuition_fee: false,
          status: "Pending",
        };

        const response = await this.$axios.post(
          "/create_student_addon_invoices",
          { addon_invoices: invoiceData },
        );

        if (response.data.data) {
          return response.data.data;
        }
      } catch (error) {
        console.error("Error creating invoice:", error);
        this.$store.commit("showSnackbar", {
          message: error.response?.data?.message || "Error creating invoice",
          color: "error",
        });
        throw error;
      }
    },
    getAddonFixedAmount(type, amount) {
      const fee = parseFloat(amount);
      if (isNaN(fee)) return "0.00";
      if (type == "Direct") return fee.toFixed(2);
      if (type == "Split") return fee.toFixed(2);
    },
    getAddonPaymentPayload(selectedOption, invoiceId) {
      return {
        mercid: this.env.merchantid,
        amount: this.getAddonFixedAmount("Direct", selectedOption.totalAmount),
        return_url: this.env.payment_option_prgm_addon_ru,
        additional_info: {
          additional_info1: this.form.application_id,
          additional_info2: this.form.email,
          additional_info3: "Add-on Programme",
          additional_info4: String(
            this.getMaxEnrollmentDeadline(selectedOption.details),
          ),
          additional_info5: String(selectedOption.ids),
          additional_info6: String(invoiceId) ,
          additional_info7: `applicant_portal,${this.applicantId},${this.studentPlanId}`,
        },
        split_payment: this.env.getSplitPayment(selectedOption.totalAmount),
      };
    },
    async processPayment(selectedOption, invoiceId) {
      this.$store.commit("showSnackbar", {
        message: "Redirecting to payment gateway...",
        color: "info",
      });
      this.loading = true;
      await this.$axios
        .post(
          this.env.billdesk_url,
          this.getAddonPaymentPayload(selectedOption, invoiceId),
        )
        .then((res) => {
          if (res.status == 200) {
            const { rdata, bdorderid, order_id, ecom_order_id, order_ref_no } =
              res.data;
            const form = document.createElement("form");
            form.method = "POST";
            form.action = this.env.billdesk_sdk_url;
            form.style.display = "none";
            const inputs = {
              bdorderid,
              merchantid: this.env.merchantid,
              rdata,
            };
            Object.entries(inputs).forEach(([name, value]) => {
              const input = document.createElement("input");
              input.type = "hidden";
              input.name = name;
              input.value = value;
              form.appendChild(input);
            });
            document.body.appendChild(form);
            this.addonCreateBilldeskHistory(
              order_id,
              ecom_order_id,
              order_ref_no,
            ).then(() => {
              this.loading = false;
              form.submit();
            });
          } else {
            this.$store.commit("showSnackbar", {
              message: res.data.message,
              color: "error",
            });
          }
        })
        .catch(() => {
          this.loading = false;
          this.$store.commit("showSnackbar", {
            message: "Error in payment, Please try again",
            color: "error",
          });
        });
    },

    async addonCreateBilldeskHistory(order_id, ecom_order_id, order_ref_no) {
      const data = {
        order_id: order_id,
        ecom_order_id: ecom_order_id,
        order_ref_no: order_ref_no,
        name: this.form.name,
        email: this.form.email,
        mobile_no: this.form.mobile_no,
        program_id: String(this.form.program_id),
        amount: String(this.applicant_addon_programmes.amount),
        current_status: "initiated",
        fee_type: "Add-on Programme",
      };
      await this.$axios
        .post(`/billdesk_track_history`, { billdesk_track_history: data })
        .then((res) => {
          console.log("saved history");
        });
    },

    getMaxEnrollmentDeadline(selectedAddons) {
      if (!selectedAddons || selectedAddons.length === 0) {
        return new Date().toISOString().split("T")[0];
      }

      const deadlines = selectedAddons.map(
        (a) => new Date(a.feeSchedule.enrollment_end),
      );
      return new Date(Math.max(...deadlines)).toISOString().split("T")[0];
    },
    async getApplicantAddonProgramme(application_id = null) {
      const appId = application_id || this.form?.application_id;

      if (!appId) {
        console.warn("No application_id available");
        return;
      }

      try {
        const response = await this.$axios.get(
          `/get_student_program_addons_by_application?application_id=${appId}`,
        );
        if (response.data.data) {
          this.applicant_addon_programmes = response.data.data[0];
        }
      } catch (error) {
        console.error("Error fetching student addon programme:", error);
      }
    },
    async showAddonProgrammes() {
      await this.getApplicantAddonProgramme();
      if (this.applicant_addon_programmes?.is_amount_paid === true) {
        this.openProgramAddonsDialog = false;
        return;
      }
      this.openProgramAddonsDialog = true;
    },
    isAddonPayment() {
      return this.fee_type === "Add-on Programme";
    },
    async handleSkipAddons(selected) {
      this.currentSelectedOption = selected?.paymentOption;

      try {
        const invoiceRes = await this.$axios.get(
          `/get_addon_invoice_by_application_id?application_id=${this.form.application_id}`,
        );
        const invoiceId = invoiceRes.data?.data?.id;
        if (invoiceId) {
          await this.$axios.delete(
            `/delete_applicant_by_addon_invoice?application_id=${this.form.application_id}`,
          );
        }
      } catch (error) {
        console.warn("No addon invoice to delete:", error);
      }

      try {
        const addonRes = await this.$axios.get(
          `/get_student_program_addons_by_application?application_id=${this.form.application_id}`,
        );
        const hasRecord = addonRes.data?.data?.length > 0;
        if (hasRecord) {
          await this.$axios.delete(
            `/delete_applicant_by_application_id?application_id=${this.form.application_id}`,
          );
        }
      } catch (error) {
        console.warn("No student addon record to delete:", error);
      }
    },
    async fetchFeeSchedules() {
      try {
        const params = {};
        if (this.form?.program_id) params.program_id = this.form?.program_id;
        if (this.form?.partner_id) params.partner_id = this.form?.partner_id;
        if (this.form?.batch) params.batch = this.form?.batch;
        if (this.form?.year) params.year = this.form?.year;

        const response = await this.$axios.get("/get_program_addons", {
          params,
        });
        this.addonfeeSchedules = response.data.data || [];
      } catch (error) {
        console.error("Error fetching fee schedules:", error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
